import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Leaf } from "lucide-react";
import { useAuth } from "../contexts/AuthContext";
import { Logo } from "../components/site/Logo";

export default function Auth({ mode = "login" }) {
  const isLogin = mode === "login";
  const { login, register } = useAuth();
  const navigate = useNavigate();
  const loc = useLocation();
  const next = new URLSearchParams(loc.search).get("next") || "/shop";

  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const upd = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    const res = isLogin
      ? await login(form.email, form.password)
      : await register(form.name, form.email, form.password);
    setLoading(false);
    if (res.ok) navigate(res.user.role === "admin" ? "/admin" : next);
    else setError(res.error);
  };

  return (
    <div className="min-h-screen bg-[#163F25] flex items-center justify-center px-6 grain">
      <div className="relative z-10 w-full max-w-md rounded-2xl bg-[#F6F5F0] p-8">
        <Link to="/" className="inline-flex mb-6"><Logo /></Link>
        <h1 className="font-display text-3xl font-bold text-[#1A1C19]">{isLogin ? "Welcome back" : "Create your account"}</h1>
        <p className="text-[#4A4D48] text-sm mt-1">{isLogin ? "Log in to your Boreal Coco account." : "Register to shop and track your orders."}</p>

        <form onSubmit={submit} data-testid="auth-form" className="mt-6 space-y-4">
          {!isLogin && (
            <input data-testid="auth-name" className="w-full rounded-xl border border-[#D1CFC8] bg-white px-4 py-3 focus:outline-none focus:border-[#1F5A34]" placeholder="Full name" value={form.name} onChange={upd("name")} required />
          )}
          <input data-testid="auth-email" type="email" className="w-full rounded-xl border border-[#D1CFC8] bg-white px-4 py-3 focus:outline-none focus:border-[#1F5A34]" placeholder="Email" value={form.email} onChange={upd("email")} required />
          <input data-testid="auth-password" type="password" className="w-full rounded-xl border border-[#D1CFC8] bg-white px-4 py-3 focus:outline-none focus:border-[#1F5A34]" placeholder="Password" value={form.password} onChange={upd("password")} required />
          {error && <p className="text-red-600 text-sm" data-testid="auth-error">{error}</p>}
          <button disabled={loading} data-testid="auth-submit" className="w-full py-3 rounded-full bg-[#1F5A34] text-[#F6F5F0] font-semibold disabled:opacity-60">
            {loading ? "Please wait…" : isLogin ? "Log in" : "Create account"}
          </button>
        </form>

        <p className="mt-5 text-sm text-[#4A4D48] text-center">
          {isLogin ? (
            <>No account? <Link to="/register" className="text-[#1F5A34] font-semibold" data-testid="link-register">Register</Link></>
          ) : (
            <>Already registered? <Link to="/login" className="text-[#1F5A34] font-semibold" data-testid="link-login">Log in</Link></>
          )}
        </p>
      </div>
    </div>
  );
}
